import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import ProtectedPage from '../components/core/ProtectedPage';
import PageLogin from '../components/login/PageLogin';
// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';

const PageSearchResults = lazy(() => import('../components/searchResults/PageSearchResults'));
const PageCompanies = lazy(() => import('../components/companies/PageCompanies'));
const PageCompanyDetail = lazy(() => import('../components/companies/PageCompanyDetail'));
const PageCompanyNew = lazy(() => import('../components/companies/PageCompanyNew'));
const PageCompanyEdit = lazy(() => import('../components/companies/PageCompanyEdit'));
const PageLicensePackageLinkSet = lazy(() => import('../components/companies/PageLicensePackageLinkSet'));
const PageAdministrationPackageLinkSet = lazy(() =>
    import('../components/administrations/PageAdministrationPackageLinkSet'),
);
const PageAdministrations = lazy(() => import('../components/administrations/PageAdministrations'));
const PageAdministrationDetail = lazy(() => import('../components/administrations/PageAdministrationDetail'));
const PageAdministrationNew = lazy(() => import('../components/administrations/PageAdministrationNew'));
const PageAdministrationEdit = lazy(() => import('../components/administrations/PageAdministrationEdit'));
const PageAdministrationConnectLicense = lazy(() => import('../components/administrations/PageConnectLicense'));
const PageApplicationDetail = lazy(() => import('../components/applications/PageApplicationDetail'));
const PageApplicationNew = lazy(() => import('../components/applications/PageApplicationNew'));
const PageApplicationEdit = lazy(() => import('../components/applications/PageApplicationEdit'));
const PageApiUsersDetail = lazy(() => import('../components/apiUsers/PageApiUsersDetail'));
const PageApiUserNew = lazy(() => import('../components/apiUsers/PageApiUserNew'));
const PageApiUserEdit = lazy(() => import('../components/apiUsers/PageApiUserEdit'));
const PageLicenseDetail = lazy(() => import('../components/licenses/PageLicenseDetail'));
const PageLicenseNew = lazy(() => import('../components/licenses/PageLicenseNew'));
const PageLicenseEdit = lazy(() => import('../components/licenses/PageLicenseEdit'));
const PageTemplates = lazy(() => import('../components/templates/PageTemplates'));
const PageTemplateDetail = lazy(() => import('../components/templates/PageTemplateDetail'));
const PageTemplateNew = lazy(() => import('../components/templates/PageTemplateNew'));
const PageTemplateEdit = lazy(() => import('../components/templates/PageTemplateEdit'));
const PageJobs = lazy(() => import('../components/jobs/PageJobs'));
const PagePaco = lazy(() => import('../components/paco/PagePaco'));


function AppRoutes() {
    const DefaultPage = AppConfig.defaultPage;
    return (
        <Routes>
            <Route path="login" element={<PageLogin />} />
            <Route element={<ProtectedPage />}>
                <Route path="companies">
                    <Route index element={<PageCompanies />} />
                    <Route path="new" element={<PageCompanyNew />} />
                    <Route path=":companyId">
                        <Route index element={<PageCompanyDetail />} />
                        <Route path="edit" element={<PageCompanyEdit />} />
                        <Route path="package_links" element={<PageLicensePackageLinkSet />} />
                        <Route path="licenses">
                            <Route path="new" element={<PageLicenseNew />} />
                            <Route path=":licenseId">
                                <Route index element={<PageLicenseDetail />} />
                                <Route path="edit" element={<PageLicenseEdit />} />
                                <Route path="administrations">
                                    <Route path="new" element={<PageAdministrationNew />} />
                                    <Route path=":administrationId">
                                        <Route index element={<PageAdministrationDetail />} />
                                        <Route path="edit" element={<PageAdministrationEdit />} />
                                        <Route path="package_links" element={<PageAdministrationPackageLinkSet />} />
                                        <Route path="connect_license" element={<PageAdministrationConnectLicense />} />
                                        <Route path="applications">
                                            <Route path="new" element={<PageApplicationNew />} />
                                            <Route path=":applicationId">
                                                <Route index element={<PageApplicationDetail />} />
                                                <Route path="edit" element={<PageApplicationEdit />} />
                                            </Route>
                                        </Route>
                                        <Route path="api_users">
                                            <Route path="new" element={<PageApiUserNew />} />
                                            <Route path=":apiUserId">
                                                <Route index element={<PageApiUsersDetail />} />
                                                <Route path="edit" element={<PageApiUserEdit />} />
                                            </Route>
                                        </Route>
                                    </Route>
                                </Route>
                                <Route path="package_links" element={<PageLicensePackageLinkSet />} />
                            </Route>
                        </Route>
                    </Route>
                </Route>
                <Route path="administrations">
                    <Route index element={<PageAdministrations />} />
                    <Route path="new" element={<PageAdministrationNew />} />
                </Route>
                <Route path="templates">
                    <Route index element={<PageTemplates />} />
                    <Route path="new" element={<PageTemplateNew />} />
                    <Route path=":templateId">
                        <Route index element={<PageTemplateDetail />} />
                        <Route path="edit" element={<PageTemplateEdit />} />
                    </Route>
                </Route>
                <Route path="jobs">
                    <Route index element={<PageJobs />} />
                </Route>
                <Route path="paco">
                    <Route index element={<PagePaco />} />
                </Route>
                <Route path="search_results">
                    <Route index element={<PageSearchResults />} />
                </Route>
            </Route>
            <Route path="*" element={<DefaultPage />} />
        </Routes>
    );
}

export default AppRoutes;
